<template>
<div id="layoutAuthentication">
            <div id="layoutAuthentication_content">
                <main>
                    <div class="container">
                        <div class="row justify-content-center mb-5">
                            <div class="col-lg-7">
                                <div class="card shadow-lg border-0 rounded-lg mt-3">
                                    <div class="card-header"><h3 class="text-center font-weight-light my-2">Create Account</h3></div>
                                    <div class="card-body">
                                        <form @submit.prevent="register_user">
                                            <div class="form-row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="small mb-1" for="inputFirstName">First Name</label>
                                                            <input class="form-control py-4" id="inputFirstName" type="text" placeholder="Enter first name" v-model="form.first_name" required/>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="small mb-1" for="inputLastName">Last Name</label>
                                                            <input class="form-control py-4" id="inputLastName" type="text" placeholder="Enter last name" v-model="form.last_name"  required/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-md-6">
                                                    <fieldset class="form-group">
                                                        <legend class="col-form-label small mb-1  pt-0">Sex</legend>
                                                                <div class="form-check ">
                                                                <input class="form-check-input" type="radio" name="gender" id="male" value="male" v-model="form.gender"  checked required>
                                                                <label class="form-check-label small mb-1" for="male">
                                                                    Male
                                                                </label>
                                                                </div>
                                                                <div class="form-check ">
                                                                <input class="form-check-input" type="radio" name="gender" v-model="form.gender" id="female" value="female" required>
                                                                <label class="form-check-label small mb-1" for="female">
                                                                    Female
                                                                </label>
                                                            </div>
                                                    </fieldset>
                                                </div>
                                                <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="small mb-1" for="inputCountry">Country</label>
                                                            <input class="form-control py-4" id="inputCountry" type="country" v-model="form.country" placeholder="Enter Your Country"  required/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-md-6">
                                                    <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Phone</label>
                                                        <input class="form-control py-4" id="inputPhone" type="tel" aria-describedby="emailHelp" placeholder="Enter Phone Number" v-model="form.phone_number" required/>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Age</label>
                                                        <input class="form-control py-4" min="0" id="inputEmailAddress" type="number" aria-describedby="emailHelp" placeholder="Enter Your Age" v-model="form.age" required/>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="form-row">
                                                <div class="col-md-6">
                                                    <div class="form-group"><label class="small mb-1" for="inputEmail">
                                                        Email</label>
                                                        <input class="form-control py-4" id="inputEmail" type="email" placeholder="Enter Email" v-model="form.email" required/>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group"><label class="small mb-1" for="inputConfirmPassword">Password</label>
                                                        <input class="form-control py-4" id="inputConfirmPassword" type="password" v-model="form.password" required placeholder="Enter password" /></div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                    <input v-model="form.terms" type="checkbox" name="terms" id="terms"/>
                                                    <label for="terms"> I agree with the Terms & Conditions </label>
                                                    <p style="" id="terms">
                                                        You confirm and agree that this content you are submitting
                                                        is your own intellectual work, and that you have the full rights
                                                        to enter it/them into this platform. You agree that upon
                                                        receipt we shall be free to distribute this work through all
                                                            channels worldwide without royalties or further recourse to 
                                                            you subject to the terms of the <a href="http://creativecommons.org/" target="_blank" @click="termsAndCondition">Creative Commons</a>. Should you 
                                                            be selected for a prize, a further agreement shall be entered into. 
                                                            You understand however that no guarantee whatsoever, expressly or
                                                            implied, is being made about your eligibility for a prize now or in
                                                            the future. You have been fully made aware that our distribution and
                                                            dissemination of your work through our channels and those of our partners 
                                                        is not predicated on your eligibility for any of our prizes now or in the future</p>
                                                    <p v-if="message"  class="text-center" style="color: red"> {{message}} </p>
                                                </div>
                                            <div class="form-group mt-4 mb-0">
                                                <button type="submit" class="btn btn-primary btn-block">
                                                        Create Account                     
                                                    <div class="spinner-grow" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="card-footer text-center">
                                        <div class="small"><a href="/user/login">Have an account? Go to login</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div> 
        </div>
</template>
<script>
    import url from '../URL'
export default {
    data() {
        return {
            form: {
                first_name:'',
                last_name:'',
                email:'',
                password:'',
                phone_number:'',
                country:'',
                age:'',
                gender:'',
                terms:''
            },
            loading: false,
            message: '',
        }
        },
    methods: {
        termsAndCondition() {
            window.open("http://creativecommons.org/")
            },
        register_user(e) {
            e.preventDefault()
             this.message = ''
             this.loading = true;

             if(!this.form.terms) {
                 this.loading = false;
                 this.message = "You must agree with our terms and conditions";
                 return;
             }

             const userData = {
                        "first_name": this.form.first_name,
                        "last_name" : this.form.last_name,
                        "email" : this.form.email ,
                        "password" : this.form.password,
                        "gender": this.form.gender,
                        "country" : this.form.country,
                        "phone_number" : this.form.phone_number,
                        "age" : this.form.age
                    } 
            const submitData = async() => {
                 
                 try {
                     const response = await this.$http.post(`${this.apiurl}/api/actioncommons/contributor/create`, userData)
                        if(response.status === 200) {
                            this.loading = false;
                            localStorage.setItem('userToken',response.data.token)
                            this.$router.push("/user/home")
                        } 
                 }catch( err){
                     
                    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

                     if(connection.type === 'none') {
                         this.loading = false
                         this.message = 'Network Error Try Again'
                     }
                     if(err.response.status === 422) {
                         this.loading = false;
                         this.message = "Invalid Credentials"
                     }
                     
                 }
            }
            submitData()
        }
 
    },
    computed: {
    apiurl() {
        return url()
    } 
}
}
</script>
<style scope>

</style>